import { useRouter } from 'next/router';
import { useEffect } from 'react';

// biome-ignore lint/suspicious/noExplicitAny: <same as node_modules/next/dist/shared/lib/mitt.d.ts>
type Handler = (...evts: any[]) => void;
interface UseRouterEventsParams {
  handler: Handler;
  type: 'routeChangeStart' | 'beforeHistoryChange' | 'routeChangeComplete' | 'routeChangeError' | 'hashChangeStart' | 'hashChangeComplete';
}
export const useRouterEvents = ({
  type,
  handler
}: UseRouterEventsParams) => {
  const router = useRouter();
  useEffect(() => {
    router.events.on(type, handler);
    return () => router.events.off(type, handler);
  }, [router.events, handler, type]);
};